export enum AccessType {
  ALLOW_LIST = 'allowList',
  BLOCK_LIST = 'blockList',
}